

import ClickOutside from 'vue-click-outside'

export default {
  name: "FormSelect",
  props: {
    height: {
      type: Number,
      required: false,
      default: 50
    },
    width: {
      type: Number,
      required: false,

    },
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    currentId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  components: {},
  data() {
    return {
      isOpen: false,
      isChosen: false,
      chosenId: 0,
      opened: false
    }
  },

  directives: {
    ClickOutside
  },

  mounted() {
    this.chosenId = this.currentId
    this.popupItem = this.$el

  },

  methods: {
    openToggle() {
      this.isOpen = !this.isOpen
    },
    toggle () {
      this.opened = !this.opened
    },

    hide () {
      this.opened = false
    },

    makeChoice(id, name, index) {
      this.$emit('makeChoice', id, name, index)
      this.hide()
      this.isChosen = true
      this.chosenId = index
    }
  }
}
